if (!customElements.get('featured-collection-slider')) {
  customElements.define('featured-collection-slider', class extends HTMLElement {
    constructor() {
      super();
      this.flickityInstance = null;
      this.screenType = window.matchMedia('(max-width:750px)').matches ? 'mobile' : 'desktop';
    }

    connectedCallback() {
      this.initFlickity();
      window.addEventListener('resize', () => {
        if ((this.screenType == 'desktop' && window.matchMedia('(max-width:750px)').matches) || (this.screenType == 'mobile' && window.matchMedia('(min-width:750px)').matches)) {
          this.screenType = window.matchMedia('(max-width:750px)').matches ? 'mobile' : 'desktop';
          if (this.flickityInstance) {
            this.flickityInstance.destroy();
          }
          this.initFlickity();
        }
      });
    }

    initFlickity() {
      let options = {
        "prevNextButtons": false,
        "pageDots": true,
        "contain": true,
        "cellAlign": "left",
        "dragThreshold": 8,
        "groupCells": true
      };

      if (window.innerWidth < 750) {
        options = {
          "prevNextButtons": false,
          "pageDots": true,
          "contain": true,
          "cellAlign": "left",
          "dragThreshold": 8,
          "groupCells": true
        };
      }

      this.flickityInstance = new Flickity(this, options);
    }
  });
}